export default __webpack_public_path__ + "static/media/road-closures.511de67c.svg";